/**
 * Hierarchical (breadth-first) traversal of tree nodes
 *
 * @author liubin.frontend
 * @param {*} root
 * @param {*} handler handler for each tree node
 * @param {boolean} [stop=() => false] stopping condition for iterating
 */
export const walkTreeBFS = ({ root, handler = (): void => {/** do nothing */}, stop = (): boolean => false }: { root: any; handler: (param?) => void; stop?: (root?: any) => boolean }): void => {
  if (!root || stop(root)) {
    return;
  }
  const queue = [root];

  handler(root);
  let stoped = false;

  while (queue.length && !stoped) {
    const { children = [] } = queue.shift();

    for (let i = 0, len = children.length; i < len; i += 1) {
      const node = children[i];
      if (stop(node)) {
        stoped = true;
        break;
      }
      queue.push(node);
      handler(node);
    }
  }
};

export const isDef = (value: any): boolean => value !== undefined && value !== null;
